import { render, staticRenderFns } from "./CohortsLogos.vue?vue&type=template&id=3786eaab&scoped=true&"
import script from "./CohortsLogos.vue?vue&type=script&lang=js&"
export * from "./CohortsLogos.vue?vue&type=script&lang=js&"
import style0 from "./CohortsLogos.vue?vue&type=style&index=0&id=3786eaab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3786eaab",
  null
  
)

export default component.exports